<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="800"
    scrollable
  >
    <v-card v-if="notification">
      <v-card-title>
        <v-chip
          small
          label
          dark
          :color="notification.notification_type | notification_type_chip_color"
        >
          <v-icon
            v-if="notification.use_important"
            left
          >
            mdi-star
          </v-icon>
          {{ notification.notification_type | notification_type_to_label }}
        </v-chip>
      </v-card-title>
      <v-card-subtitle class="mt-1">
        {{ notification.title }}
      </v-card-subtitle>
      <v-divider />
      <v-card-text style="height: 300px;">
        <div class="line-break">
          {{ notification.message }}
        </div>
      </v-card-text>
      <v-card-text class="text-right">
        {{ notification.notification_at }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      notification: null,
    }
  },
  watch: {
    enableDialog (value) {
      Object.assign(this.$data, this.$options.data())
      if (value) {
        if (this.targetId) {
          this.searchShowNotification()
        }
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverNotification', {
      showNotification: 'show',
      readNotification: 'update'
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 詳細表示情報取得
     */
    searchShowNotification () {
      this.showNotification({ id: this.targetId }).then((content) => {
        this.notification = content
        this.readNotification({id: this.targetId}).then((content) => {
          this.$emit('refreshEvent', this.targetId)
        })
      })
    },
  }
}
</script>
